<template>
    <div class="xz">
        <div class="danyuan">
            <span>楼宇信息</span>
        </div>
        <div class="lyxx">
            <div><span>楼栋号：</span>{{currhouse.buildingNo}}</div>
            <div style="width:35%"><span>单元号：</span>{{currhouse.unitName}}</div>
            <div><span>楼层：</span>{{currhouse.floorNum}}</div>
            <div style="width:35%"><span>房屋号：</span>{{currhouse.roomNo}}</div>
        </div>
        <div class="danyuan">
            <span>入住人信息</span>
        </div>
        <div class="lyxx">
            <div><span>姓名：</span>{{userInfo.trueName}}</div>
            <div><span>联系电话：</span>{{userInfo.phone}}</div>
            <div class="tbsj"><span>填报时间：</span>{{tbsj}}</div>
        </div>
        <div class="danyuan">
            <span>住户信息</span>
        </div>
        <van-cell-group>
            <van-field type="digit" v-model="xzlist.community_count" required :readonly ='isreadonly' label="家庭人口总数" maxlength='20' placeholder="请输入家庭人口总数" input-align="right" ></van-field>
            <van-field type="digit" v-model="xzlist.chronic_disease_count" :readonly ='isreadonly' label="慢性病患者数量" maxlength='20' placeholder="请输入慢性病患者数量" input-align="right" ></van-field>
            <van-field type="digit" v-model="xzlist.disable_old_count" :readonly ='isreadonly' label="失能人数量" maxlength='20' placeholder="请输入失能人数量" input-align="right" ></van-field>
            <van-field type="digit" v-model="xzlist.disable_man_count" :readonly ='isreadonly' label="残疾人数量" maxlength='20' placeholder="请输入残疾人数量" input-align="right" ></van-field>
            <van-field type="digit" v-model="xzlist.baby_count"  :readonly ='isreadonly' label="婴幼儿数量" maxlength='20' placeholder="请输入婴幼儿数量" input-align="right" ></van-field>
            <van-field type="digit" v-model="xzlist.low_income_count" :readonly ='isreadonly' label="低保对象数量" maxlength='20' placeholder="请输入低保对象数量" input-align="right" ></van-field>
            <van-field type="digit" v-model="xzlist.single_old_count" :readonly ='isreadonly' label="孤寡老人数量" maxlength='20' placeholder="请输入孤寡老人数量" input-align="right" ></van-field>
        </van-cell-group>
        <div class="danyuan">
            <span>每周家庭需求总量</span>
        </div>
        <van-cell-group>
            <van-field v-model="xzlist.rice_noodles_quantity"  label="米面(斤)" readonly  maxlength='20' placeholder="" input-align="right" ></van-field>
            <van-field v-model="xzlist.meat_quantity"  label="肉类(斤)" readonly  maxlength='20' placeholder="" input-align="right" ></van-field>
            <van-field v-model="xzlist.vegetable_quantity"  label="蔬菜(斤)" readonly  maxlength='20' placeholder="" input-align="right" ></van-field>
            <van-field v-model="xzlist.cooking_oil_amount"  label="食用油(斤)" readonly  maxlength='20' placeholder="" input-align="right" ></van-field>
            <van-field v-model="xzlist.egg_amount"  label="鸡蛋(个)" readonly  maxlength='20' placeholder="" input-align="right" ></van-field>
            <van-field v-model="xzlist.milk_count"  label="牛奶(升)" readonly  maxlength='20' placeholder="" input-align="right" ></van-field>
            <van-field v-model="xzlist.milk_powder_count"  label="品牌奶粉(斤)" readonly  maxlength='20' placeholder="" input-align="right" ></van-field>
            <van-field type="textarea" v-model="xzlist.milk_powder_brand" :required='isyye' label="品牌奶粉名称" :readonly ='isreadonly' placeholder="请输入品牌奶粉名称" input-align="right" ></van-field>
        </van-cell-group>
        <div class="danyuan">
            <span>慢性病药品（一周量）</span>
        </div>
        <div class="yaop">
            <div style="display: flex;align-items: center;justify-content: center;">
                <span>名称</span>
            </div>
            <div style="display: flex;align-items: center;justify-content: center;">
                <span>数量（盒）</span>
            </div>

        </div>
        <div class="yaopmen">
            <div class="srk" v-for="(item,index) in yplist" :key="index">
                <div>
                    <input type="text" v-model="item.name" :placeholder="pch1" :readonly ='isreadonly'>
                </div>
                <div>
                    <input type="text" v-model="item.value" :placeholder="pch2" :readonly ='isreadonly'>
                </div>
            </div>
            <!-- <button class="addyp">添加</button> -->
        </div>
        
        <button class="anniu" v-show="firstadd" :class="{'disab':issuccess}" @click="tijiao">提交</button>
        <button class="anniu" v-show="canedit" :class="{'disab':issuccess}" @click="bianji">编辑</button>
        <button class="anniu" v-show="secondadd" :class="{'disab':issuccess}" @click="xiugai">保存</button>
        
    </div>
</template>
<script>
import {
    mapState,
    mapMutations
} from 'vuex';
export default {
    data() {
        return {
            canedit:false,
            isreadonly:false,
            issuccess:false,
            firstadd:true,
            secondadd:false,
            isyye:false,
            tbsj:'',
            pch1:'请输入药品名称',
            pch2:'请输入数量',
            yplist:[
                {
                    name:'',
                    value:''
                },{
                    name:'',
                    value:''
                },{
                    name:'',
                    value:''
                },{
                    name:'',
                    value:''
                },{
                    name:'',
                    value:''
                },
            ],
            xzlist:{
                community_count:'',
                chronic_disease_count:'',
                disable_old_count:'',
                disable_man_count:'',
                baby_count:'',
                low_income_count:'',
                single_old_count:'',
                rice_noodles_quantity:'',
                meat_quantity:'',
                vegetable_quantity:'',
                cooking_oil_amount:'',
                egg_amount:'',
                milk_count:'',
                milk_powder_count:'',
                milk_powder_brand:'',
            },
            userInfo:{},
            currhouse:'',
            addname:[],
        }
    },
    watch:{
        'xzlist.community_count': {
            handler (val) {
                console.log(typeof(val))
                this.xzlist.rice_noodles_quantity = (val*0.7*7).toFixed(2)
                this.xzlist.meat_quantity = (val*0.1*7).toFixed(2)
                this.xzlist.vegetable_quantity = (val*1*7).toFixed(2)
                this.xzlist.cooking_oil_amount = (val*0.05*7).toFixed(2)
                this.xzlist.egg_amount = (val*7)
                this.xzlist.milk_count = (val*250*7/1000).toFixed(2)
            },
            deep: true
        },
        'xzlist.baby_count': {
            handler (val) {
                console.log(typeof(val))
                if(Number(val)>Number(this.xzlist.community_count)){
                    this.$toast.fail('人数不得超过家庭总人口')
                    this.xzlist.baby_count = this.xzlist.community_count
                }
                this.isyye = (val!='' && val>0) ? true : false
                this.xzlist.milk_powder_count = (val!='' && val>0) ? (val*0.05*7).toFixed(2) : 0
            },
            deep: true
        },
        'xzlist.chronic_disease_count': {
            handler (val) {
                if(Number(val)>Number(this.xzlist.community_count)){
                    this.$toast.fail('人数不得超过家庭总人口')
                    this.xzlist.chronic_disease_count = this.xzlist.community_count
                }
            },
            deep: true
        },
        'xzlist.disable_old_count': {
            handler (val) {
                if(Number(val)>Number(this.xzlist.community_count)){
                    this.$toast.fail('人数不得超过家庭总人口')
                    this.xzlist.disable_old_count = this.xzlist.community_count
                }
            },
            deep: true
        },
        'xzlist.disable_man_count': {
            handler (val) {
                if(Number(val)>Number(this.xzlist.community_count)){
                    this.$toast.fail('人数不得超过家庭总人口')
                    this.xzlist.disable_man_count = this.xzlist.community_count
                }
            },
            deep: true
        },
        'xzlist.low_income_count': {
            handler (val) {
                if(Number(val)>Number(this.xzlist.community_count)){
                    this.$toast.fail('人数不得超过家庭总人口')
                    this.xzlist.low_income_count = this.xzlist.community_count
                }
            },
            deep: true
        },
        'xzlist.single_old_count': {
            handler (val) {
                if(Number(val)>Number(this.xzlist.community_count)){
                    this.$toast.fail('人数不得超过家庭总人口')
                    this.xzlist.single_old_count = this.xzlist.community_count
                }
            },
            deep: true
        },
    },
    mounted() {
        this.tbsj = this.timeFormat(new Date())
        this.$axios.get('/api/v2/wechat/user/userInfo', {
            params: {}
        }).then(res => {
            this.userInfo=res
            this.currhouse=res.houses.filter(item=>{
                return item.isDefault
            })[0]
            this.getdata()
        });
        
    },
    methods: {
        bianji(){
            this.isreadonly = false
            this.canedit = false
            this.secondadd = true
            this.firstadd = false
        },
        getdata(){
            this.$axios.post('/api/v1/qzxq/getQzxqDetail',{

            }).then(res=>{
                if(JSON.stringify(res) != "{}"){
                    this.xzlist = res
                    this.isreadonly = true
                    this.pch1 = '无'
                    this.pch2 = 0
                    for(var i=0;i<=4;i++){
                         this.yplist[i].name = res['mxbyp_name'+(i+1)]
                        if(res['mxbyp_name'+(i+1)]){
                            this.yplist[i].value = res['mxbyp_count'+(i+1)]
                        }else{
                            this.yplist[i].value = ''
                        }
                        
                        
                    }
                    if(this.xzlist.lrry == this.userInfo.trueName){
                        this.canedit = true
                        this.firstadd = false
                        this.secondadd = false
                    }else{
                        this.canedit = false
                        this.firstadd = false
                        this.secondadd = false
                    }
                }else{
                    this.firstadd = true
                    this.secondadd = false
                    this.canedit = false
                }
                
            })
        },
        timeFormat(time) { // 时间格式化 2019-09-08
            console.log(time)
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let day = time.getDate();
            let hour = time.getHours();
            let mint = time.getMinutes()
            let sec = time.getSeconds()
            if (month < 10) month = "0" + month;
            if (day < 10) day = "0" + day;
            if (hour < 10) hour = "0" + hour;
            if (mint < 10) mint = "0" + mint;
            return year + '-' + month + '-' + day + ' '+hour+':'+mint
        },
        xiugai(){
            if(this.xzlist.community_count==''){
                this.$toast.fail('家庭总人口未填写！')
            }else if(this.isyye && this.xzlist.milk_powder_brand == ''){
                this.$toast.fail('奶粉品牌未填写！')
            }else{
                var obj = {
                    community_count:this.xzlist.community_count,
                    chronic_disease_count:this.xzlist.chronic_disease_count,
                    disable_old_count:this.xzlist.disable_old_count,
                    disable_man_count:this.xzlist.disable_man_count,
                    baby_count:this.xzlist.baby_count,
                    low_income_count:this.xzlist.low_income_count,
                    single_old_count:this.xzlist.single_old_count,
                    name:this.userInfo.trueName,
                    telephone:this.userInfo.phone,
                    rice_noodles_quantity:this.xzlist.rice_noodles_quantity,
                    meat_quantity:this.xzlist.meat_quantity,
                    vegetable_quantity:this.xzlist.vegetable_quantity,
                    cooking_oil_amount:this.xzlist.cooking_oil_amount,
                    egg_amount:this.xzlist.egg_amount,
                    milk_count:this.xzlist.milk_count,
                    milk_powder_count:this.xzlist.milk_powder_count,
                    milk_powder_brand:this.xzlist.milk_powder_brand,
                    lrry:this.userInfo.trueName,
                    lrsj:this.tbsj,
                    id:this.xzlist.id
                }
                for(var i=0;i<=4;i++){
                    obj['mxbyp_name'+(i+1)] = this.yplist[i].name
                    obj['mxbyp_count'+(i+1)] = Number(this.yplist[i].value) || 0
                }
                this.$axios.post('/api/v1/qzxq/edit',obj).then(res=>{
                    if(res){
                        this.$toast.success('成功！')
                        setTimeout(() => {
                            this.$router.go(-1)
                        }, 1000);
                    }
                })
            }
        },
        tijiao(){
            this.xzlist.milk_powder_count = (this.xzlist.baby_count!='' && this.xzlist.baby_count>0) ? (this.xzlist.baby_count*0.05*7).toFixed(2) : 0
            if(this.xzlist.community_count==''){
                this.$toast.fail('家庭总人口未填写！')
            }else if(this.isyye && this.xzlist.milk_powder_brand == ''){
                this.$toast.fail('奶粉品牌未填写！')
            }else{
                var obj = {
                    community_count:this.xzlist.community_count,
                    chronic_disease_count:this.xzlist.chronic_disease_count,
                    disable_old_count:this.xzlist.disable_old_count,
                    disable_man_count:this.xzlist.disable_man_count,
                    baby_count:this.xzlist.baby_count,
                    low_income_count:this.xzlist.low_income_count,
                    single_old_count:this.xzlist.single_old_count,
                    name:this.userInfo.trueName,
                    telephone:this.userInfo.phone,
                    rice_noodles_quantity:this.xzlist.rice_noodles_quantity,
                    meat_quantity:this.xzlist.meat_quantity,
                    vegetable_quantity:this.xzlist.vegetable_quantity,
                    cooking_oil_amount:this.xzlist.cooking_oil_amount,
                    egg_amount:this.xzlist.egg_amount,
                    milk_count:this.xzlist.milk_count,
                    milk_powder_count:this.xzlist.milk_powder_count,
                    milk_powder_brand:this.xzlist.milk_powder_brand,
                    lrry:this.userInfo.trueName,
                    lrsj:this.tbsj
                }
                for(var i=0;i<=4;i++){
                    obj['mxbyp_name'+(i+1)] = this.yplist[i].name
                    obj['mxbyp_count'+(i+1)] = Number(this.yplist[i].value) || 0
                }
                console.log(obj)
                this.$axios.post('/api/v1/qzxq/add',obj).then(res=>{
                    if(res){
                        this.$toast.success('成功！')
                        setTimeout(() => {
                            this.$router.go(-1)
                        }, 1000);
                    }
                })
            }
        }
    },
}
</script>
<style lang="less">
    input::-webkit-input-placeholder { 
        /* WebKit browsers */ 
        color: #ccc; 
    } 
    .xz{
        width: 100%;
        .yaop{
            display: flex;
            div{
                width: 50%;
                height: 30px;
            }
            
        }
        .yaopmen{
            display: flex;
            flex-direction: column;
            align-items: center;
            .srk{
                display: flex;
                justify-content: center;
                margin-top:10px;
                div{
                    width: 50%;
                    height: 30px;
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    input{
                        width: 100%;
                        outline:none;
                        border:none;
                        border-bottom:1px solid #ebedf0;
                        text-align:center;
                    }
                }
            }
        }
        .lyxx{
            box-sizing: border-box;
            padding: 0px 25px 10px 25px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            color: #808080;
            font-size: 13px;
            justify-content: space-between;
            div{
                width: 50%;
                margin-top: 10px;
            }
            .tbsj{
                width: 100% !important;
            }
        }
        .anniu{
            height: 35px;
            width: 80%;
            margin-left: 10%;
            background: #0089ff;
            border-radius: 20px;
            color: #fff;
            outline: none;
            border: none;
            margin-top: 10px;
            margin-bottom: 10px;
        }
        .disab{
            pointer-events: none;
            cursor: default;
        }
        .greyline{
            height: 13px;
            width: 100%;
            background: #f6f6f6;
        }
        .danyuan{
            height: 45px;
            width: 100%;
            background: #f6f6f6;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            padding: 0 15px;
            .blueline{
                height: 14px;
                width: 6px;
                background: #0089ff;
            }
            span{
                margin-left: 5px;
                font-size: 14px;
                color: #00b5ff;
                font-weight: bold;
            }
        }
        /deep/ .van-cell-group{
            width: 100%;
        }
    }
    /deep/.van-field__label{
        width: 7.2em !important;
        color: #808080;
        font-size: 13px;
    }
    /deep/.van-field__control{
        color: #808080;
        font-size: 13px;
    }
    /deep/.van-cell{
        padding: 10px 25px !important;
    }
</style>